// src/data/expertiseData.js

// --- SAP Data ---
export const sapModules = [
  {
    title: 'SAP ABAP',
    items: [
      'Custom reports and forms (SmartForms, SAPScript)',
      'Enhancements and modifications (User exits, BAdIs, Enhancement Framework)',
      'Interface development (IDocs, RFCs, Web Services)',
      'SAP Fiori and UI5 development for modern user interfaces',
    ],
  },
  {
    title: 'SAP MM (Materials Management)',
    items: [
      'Procurement process optimization',
      'Inventory and warehouse management',
      'Vendor evaluation and sourcing',
      'Integration with finance and sales modules',
    ],
  },
  {
    title: 'SAP SD (Sales and Distribution)',
    items: [
      'Order-to-Cash (O2C) process optimization',
      'Pricing, discounts, and taxation configuration',
      'Billing and invoice management',
      'Sales reporting and analytics',
    ],
  },
  {
    title: 'SAP BTP (Business Technology Platform)',
    items: [
      'SAP Integration Suite for seamless connectivity',
      'SAP Extension Suite for customized applications',
      'SAP Workflow Management for process automation',
      'Cloud application development using SAP BTP',
    ],
  },
  {
    title: 'SAP S/4HANA',
    items: [
      'Greenfield and brownfield implementations',
      'Migration from SAP ECC to S/4HANA',
      'Process optimization and automation',
      'Custom development for industry-specific requirements',
    ],
  },
  {
    title: 'SAP C4C (Cloud for Customer)',
    items: [
      'Implementation and customization of SAP Sales and Service Cloud',
      'Integration with SAP ERP and third-party applications',
      'Customer analytics and reporting',
      'AI-powered customer service automation',
    ],
  },
];

export const liveProjectsLearnersSAP = [
    'SAP ABAP: Development of custom reports, enhancements, and ALV reports',
    'SAP MM: Automating the procurement process and material stock movement tracking',
    'SAP SD: Implementing order management and billing automation',
    'SAP BTP: Integrating SAP S/4HANA with third-party applications',
    'SAP S/4HANA: End-to-end migration from SAP ECC to S/4HANA',
    'SAP C4C: Developing a customer service portal with real-time analytics'
];

export const liveProjectsBusinessesSAP = [
    'SAP ERP Implementation – Full-cycle SAP implementation based on business needs',
    'SAP Integration – Connecting SAP with third-party systems and applications',
    'SAP Process Automation – Automating business processes using SAP Workflow and BTP',
    'Custom SAP Development – Developing tailored SAP solutions to meet industry-specific needs'
];

export const businessBenefitsSAP = [
    'Improved operational efficiency with SAP automation',
    'Real-time analytics for better decision-making',
    'Reduced manual efforts and errors in business processes',
    'Seamless integration with cloud and third-party systems'
];

export const recentProjectsSAP = [
    { title: 'SAP CPI Integration for HR Automation', description: 'Integrated SuccessFactors modules for automated annual leave deductions and balance transfers for a global company.' },
    { title: 'SAP S/4HANA Migration', description: 'Migrated a manufacturing firm from SAP ECC to S/4HANA with optimized processes.' },
    { title: 'SAP BTP Workflow Automation', description: 'Implemented a digital approval workflow for a logistics company.' },
    { title: 'SAP MM & SD Integration', description: 'Streamlined procurement and sales processes for an e-commerce business.' }
];

export const trainingOfferingsSAP = [
    'Corporate Training – Custom SAP training for businesses',
    'Online & Offline Training – Flexible training options',
    'SAP Certification Preparation – Comprehensive coaching',
    'Hands-on Project Experience – Real-world scenarios'
];

export const trainingModulesSAP = [
    'SAP ABAP – Coding, reports, enhancements, and debugging',
    'SAP MM – Procurement, inventory, and material valuation',
    'SAP SD – Order processing, billing, and customer interactions',
    'SAP BTP – Cloud integration, workflow automation, and extensions',
    'SAP S/4HANA – ERP migration, analytics, and system configuration',
    'SAP C4C – Customer engagement and sales automation'
];

export const whyChooseUsSAP = [
    'Expert SAP Consultants – A team of certified SAP professionals with years of experience',
    'Tailored SAP Solutions – Custom implementation and training programs for every business',
    'Industry-Specific Expertise – Serving various industries with domain-driven SAP solutions',
    'Live SAP Projects – Hands-on training with real-time project experience',
    '24/7 Support & Maintenance – Dedicated assistance to ensure business continuity'
];

// --- Salesforce Data ---
export const salesforceModules = [
  {
    title: 'Sales Cloud',
    items: [
      'Lead and opportunity management optimization',
      'Sales process automation (Workflow, Process Builder, Flow)',
      'Forecasting and pipeline management',
      'Integration with marketing automation tools',
    ],
  },
  {
    title: 'Service Cloud',
    items: [
      'Case management and support process automation',
      'Omni-channel customer service setup (Email, Phone, Chat)',
      'Knowledge base implementation',
      'Field service management (FSL)',
    ],
  },
  {
    title: 'Marketing Cloud',
    items: [
      'Customer journey building and automation',
      'Email marketing and personalization',
      'Social media engagement and advertising',
      'Analytics and campaign performance tracking',
    ],
  },
  {
    title: 'Experience Cloud (Community)',
    items: [
      'Building customer and partner portals',
      'Self-service community setup',
      'Custom branding and user experience design',
      'Integration with Sales and Service Cloud data',
    ],
  },
  {
    title: 'Platform (Force.com)',
    items: [
      'Custom application development using Apex and Lightning Web Components (LWC)',
      'Data modeling and security configuration',
      'Integration using APIs (REST, SOAP)',
      'Building scalable and secure enterprise applications',
    ],
  },
  {
    title: 'CRM Analytics (Tableau CRM)',
    items: [
      'Building interactive dashboards and reports',
      'Data preparation and transformation',
      'Predictive insights using Einstein Discovery',
      'Embedding analytics within Salesforce',
    ],
  },
];

export const liveProjectsLearnersSF = [
    'Sales Cloud: Developing custom lead scoring and routing rules',
    'Service Cloud: Implementing an automated case escalation process',
    'Marketing Cloud: Building a multi-channel customer onboarding journey',
    'Experience Cloud: Creating a branded self-service portal for customers',
    'Platform: Building a custom project management application',
    'CRM Analytics: Designing sales performance dashboards'
];

export const liveProjectsBusinessesSF = [
    'CRM Implementation – Migrating legacy CRM data to Salesforce',
    'Salesforce Integration – Connecting Salesforce with ERP and marketing tools',
    'Process Automation – Automating complex business workflows using Flow',
    'Custom Development – Building bespoke Salesforce applications for specific needs'
];

export const businessBenefitsSF = [
    '360-degree view of customer interactions',
    'Increased sales team productivity and efficiency',
    'Improved customer service and satisfaction rates',
    'Data-driven decision making with advanced analytics'
];

export const recentProjectsSF = [
    { title: 'Salesforce Sales Cloud Optimization', description: 'Streamlined lead-to-opportunity process for a SaaS company, improving conversion rates.' },
    { title: 'Service Cloud Implementation for Support', description: 'Implemented Service Cloud with Omni-Channel routing for a retail client.' },
    { title: 'Experience Cloud Partner Portal', description: 'Built a secure portal for channel partners to manage leads and deals.' },
    { title: 'Salesforce Integration with SAP', description: 'Integrated Sales Cloud with SAP S/4HANA for seamless data flow.' }
];

export const trainingOfferingsSF = [
    'Corporate Salesforce Training – Tailored programs for sales, service, and marketing teams',
    'Online & Classroom Training – Flexible learning options',
    'Salesforce Certification Coaching – Admin, Developer, Consultant tracks',
    'Real-world Project Experience – Hands-on learning with live scenarios'
];

export const trainingModulesSF = [
    'Salesforce Administrator – Setup, configuration, security, data management',
    'Salesforce Developer (Apex, LWC) – Custom coding, triggers, Lightning components',
    'Sales Cloud Consultant – Sales processes, automation, reporting',
    'Service Cloud Consultant – Support processes, case management, Knowledge',
    'Marketing Cloud Specialist – Journey Builder, Email Studio, Automation Studio',
    'Experience Cloud Consultant – Portal setup, branding, user management'
];

export const whyChooseUsSF = [
    'Certified Salesforce Experts – Deep knowledge across various Salesforce clouds',
    'Customized Salesforce Solutions – Tailored implementations to fit your business model',
    'Industry-Specific Blueprints – Proven solutions for different sectors',
    'Focus on User Adoption – Ensuring your team effectively uses the platform',
    'Continuous Support & Enhancement – Ongoing assistance for optimal performance'
];

// --- Dynamics 365 Data ---
export const dynamicsModules = [
  {
    title: 'Dynamics 365 Sales',
    items: [
      'Lead and opportunity tracking',
      'Sales forecasting and performance insights',
      'Relationship selling with LinkedIn Sales Navigator integration',
      'Mobile sales capabilities',
    ],
  },
  {
    title: 'Dynamics 365 Customer Service',
    items: [
      'Omnichannel customer engagement (web, chat, mobile, social)',
      'AI-powered virtual agents and suggestions',
      'Case management and resolution tracking',
      'Self-service portals and knowledge management',
    ],
  },
  {
    title: 'Dynamics 365 Field Service',
    items: [
      'Work order management and scheduling optimization',
      'Resource management and dispatching',
      'Connected Field Service with IoT integration',
      'Mobile technician support and asset management',
    ],
  },
  {
    title: 'Dynamics 365 Finance',
    items: [
      'Financial planning and analysis',
      'Core financial management (GL, AP, AR)',
      'Budgeting, project accounting, and expense management',
      'Global financial reporting and compliance',
    ],
  },
  {
    title: 'Dynamics 365 Supply Chain Management',
    items: [
      'Planning, production, inventory, and warehouse management',
      'Transportation management and logistics',
      'Asset management and procurement',
      'Predictive insights for demand forecasting',
    ],
  },
  {
    title: 'Dynamics 365 Business Central',
    items: [
      'Comprehensive ERP for small and medium businesses',
      'Finance, sales, service, and operations management',
      'Project management and supply chain capabilities',
      'Easy integration with other Microsoft services',
    ],
  },
];

export const liveProjectsLearnersD365 = [
    'D365 Sales: Customizing the lead qualification process',
    'D365 Customer Service: Setting up automated case routing rules',
    'D365 Field Service: Developing a mobile inspection checklist',
    'D365 Finance: Configuring chart of accounts and financial dimensions',
    'D365 SCM: Implementing warehouse management system (WMS) processes',
    'D365 Business Central: Migrating data from legacy accounting software'
];

export const liveProjectsBusinessesD365 = [
    'ERP Implementation – Deploying D365 Finance & Operations or Business Central',
    'CRM Implementation – Setting up D365 Sales, Customer Service, or Marketing',
    'Dynamics 365 Integration – Connecting D365 with Power Platform, Azure, and third-party apps',
    'Custom Development – Building custom entities, workflows, and reports in D365'
];

export const businessBenefitsD365 = [
    'Unified view of business operations and customer data',
    'Improved process efficiency through automation and AI',
    'Enhanced collaboration across departments',
    'Scalable platform that grows with your business'
];

export const recentProjectsD365 = [
    { title: 'Dynamics 365 Business Central Implementation', description: 'Implemented Business Central for a growing distribution company, unifying finance and operations.' },
    { title: 'Dynamics 365 Customer Service Setup', description: 'Deployed D365 Customer Service with AI chatbots for an online retailer.' },
    { title: 'Dynamics 365 Field Service Optimization', description: 'Optimized scheduling and resource management for a utility service provider.' },
    { title: 'Power Platform Integration with D365 Sales', description: 'Built custom Power Apps integrated with D365 Sales for enhanced mobile access.' }
];

export const trainingOfferingsD365 = [
    'Corporate Dynamics 365 Training – Role-based training for users and administrators',
    'Online & On-site Workshops – Focused sessions on specific modules',
    'Dynamics 365 Certification Preparation – MB series certifications',
    'Hands-on Labs & Project Work – Practical application of learned concepts'
];

export const trainingModulesD365 = [
    'D365 Sales Functional Consultant (MB-210)',
    'D365 Customer Service Functional Consultant (MB-230)',
    'D365 Finance Functional Consultant (MB-310)',
    'D365 Supply Chain Management Functional Consultant (MB-330)',
    'D365 Business Central Functional Consultant (MB-800)',
    'Power Platform Fundamentals (PL-900) & App Maker (PL-100)'
];

export const whyChooseUsD365 = [
    'Microsoft Certified Professionals – Expertise across the Dynamics 365 suite',
    'Holistic Business Solutions – Combining CRM, ERP, and Power Platform capabilities',
    'Proven Implementation Methodologies – Ensuring successful project delivery',
    'Focus on Business Outcomes – Aligning technology with your strategic goals',
    'End-to-End Service – From consulting and implementation to training and support'
]; 